import Requests from "../../utils/Requests"

const getDefaultState = () => {
    return {
        ordering: false,
        loading: false,
        memberCompletion: 0,
        obligationOutstanding: 0,
        transactions: [],
        wallet: {
            balance: 0
        },
        showError: false,
        alertError: {}
    }
}

const loadDashboard = instance => {

    instance.setState({
        ...instance.state,
        loading: true
    })

    Requests(instance.props)
        .withGet()
        .withUrl('/api/dashboard/member')
        .withAuthorization(instance.props.auth.authorizationToken)
        .then(response => handleLoadDashboardResponse(instance, response), error => handleError(instance, error))
}

const handleLoadDashboardResponse = (instance, response) => {
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                loading: false,
                memberCompletion: response.data.memberCompletion,
                obligationOutstanding: response.data.obligationOutstanding,
                transactions: response.data.transactions,
                wallet: response.data.wallet
            })
            break;
        default:
            instance.setState({
                ...instance.state,
                loading: false
            })
            alert(response.message)
    }
}

const handleError = (instance, error) => {
    instance.setState({
        ...instance.state,
        loading: false
    })

    alert(error)

}

const Service = instance => {
    return {
        loadDashboard: () => loadDashboard(instance),
        getDefaultState: () => getDefaultState(instance)
    }
}

export default Service